export default __webpack_public_path__ + "static/media/mine.068da055.svg";